<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>
	<c-header></c-header>

	<div class="p-become-a-sponsor">
		<div class="navigation">
			<a href="/sponsors">Our sponsors</a>
			<a class="active">Become our sponsor</a>
		</div>

		<div class="container">
			<div class="head-wrapper">
				<div class="head-wrapper_map-wrapper">
					<img class="head-map-bg" width="908" height="428" src="{{@shared.assetsHost}}/img/sponsors/map.svg" />
				</div>

				<div class="head-title">
					<span>Become a sponsor</span>
					<span>and help us make jsDelivr better</span>
				</div>

				<div class="head-subtitle">
					Support us
				</div>

				<div class="head-descr">
					Support jsDelivr by donating to us through GitHub Sponsors and Open Collective and help cover the expenses of our
					infrastructure and sponsor the development of new features
				</div>

				<div class="head-ctrls">
					<a target="_blank" rel="noopener noreferrer" href="https://github.com/sponsors/jsdelivr">
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/github.black.svg" />
						GitHub Sponsors
					</a>
					<a target="_blank" rel="noopener noreferrer" href="https://opencollective.com/jsdelivr">
						<img width="18" height="18" src="{{@shared.assetsHost}}/img/icons/open-collective.svg" />
						Open Collective
					</a>
				</div>
			</div>

			<h3 class="main-title">For corporate Sponsors</h3>

			<div class="plans_tabs">
				<a class="plans_tabs_tab {{#unless activePlan}}active{{/unless}}">Platinum</a>
				<a class="plans_tabs_tab {{#if activePlan === 'gold'}}active{{/if}}">Gold</a>
				<a class="plans_tabs_tab {{#if activePlan === 'bronze'}}active{{/if}}">Bronze</a>
			</div>

			<div class="plans_wrapper">
				<div class="plans_wrapper_plans-list">
					<div class="plans_wrapper_plans-list_plan platinum">
						<div class="sp-topline">&nbsp;</div>
						<div class="sp-top">
						<div class="sp-level platinum">platinum</div>
							<div class="amount">
								$1,500 +
								<div class="sp-tooltip">$1,500/month worth of services,<br /> developer hours or monthly donation</div>
							</div>
							<div class="month">/month</div>

							<div class="sp-desc">$1500/month worth of services, developer hours or monthly donation</div>
						</div>

						<a class="sp-button" href="mailto:d@jsdelivr.com?subject=Become a platinum sponsor">Become a sponsor</a>

						<a href="/sponsors#platinum" class="sample">Sample</a>

						<div class="sp-divider"></div>

						<div class="plan-feautures">
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Big logo on top, on "Sponsors" page along with a text description</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Logo + link in header
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Tweet
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Blog post announcing the sponsorship
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Mentions future in blog posts on third-party websites
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Other possible partnership opportunities
							</div>
						</div>
					</div>

					<div class="plans_wrapper_plans-list_plan gold">
						<div class="sp-topline">&nbsp;</div>
						<div class="sp-top">
							<div class="sp-level gold">gold</div>
							<div class="amount gold">
								$500
								<div class="sp-tooltip">$500/month worth of services,<br /> developer hours or monthly donation</div>
							</div>
							<div class="month">/month</div>

								<div class="sp-desc">$500/month worth of services, developer hours or monthly donation</div>
						</div>

						<a class="sp-button" href="mailto:d@jsdelivr.com?subject=Become a gold sponsor">Become a sponsor</a>

						<a href="/sponsors#gold" class="sample">Sample</a>

						<div class="sp-divider"></div>

						<div class="plan-feautures">
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Logo + link below Platinum sponsors on "Sponsors" page. Small description
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Logo + link in header
							</div>
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Tweet
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Blog post announcing the sponsorship
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Mentions future in blog posts on third-party websites
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Other possible partnership opportunities
							</div>
						</div>
					</div>

					<div class="plans_wrapper_plans-list_plan bronze">
						<div class="sp-topline">&nbsp;</div>
						<div class="sp-top">
							<div class="sp-level bronze">bronze</div>
							<div class="amount">
								$150
								<div class="sp-tooltip">$150/month worth of services,<br /> developer hours or monthly donation
								</div>
							</div>
							<div class="month">/month</div>

								<div class="sp-desc">$150/month worth of services, developer hours or monthly donation</div>
						</div>

						<a class="sp-button" href="mailto:d@jsdelivr.com?subject=Become a bronze sponsor">Become a sponsor</a>

						<a href="/sponsors#bronze" class="sample">Sample</a>

						<div class="sp-divider"></div>

						<div class="plan-feautures">
							<div>
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg" />
								Logo + link below Gold sponsors on "Sponsors" page. No description
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Logo + link in header
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Tweet
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Blog post announcing the sponsorship
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Mentions future in blog posts on third-party websites
							</div>
							<div class="disabled">
								<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg" />
								Other possible partnership opportunities
							</div>
						</div>
					</div>

					<div class="plans_wrapper_plans-list_plan custom">
						<div class="sp-topline">&nbsp;</div>
						<div class="sp-top">
							<div class="sp-level custom">custom</div>
						</div>

						<div class="sp-text">
							For companies that want to offer a smaller or bigger amount than the ones listed above and/or have custom requirements from jsDelivr.
						</div>

						<a class="sp-button" href="mailto:d@jsdelivr.com?subject=Become a custom sponsor">Become a sponsor</a>
					</div>
				</div>
			</div>

			<div class="plans_rows">
				<div class="plans_rows_row {{#unless activePlan}}active{{/unless}}"></div>
				<div class="plans_rows_row {{#if activePlan === 'gold'}}active{{/if}}"></div>
				<div class="plans_rows_row {{#if activePlan === 'bronze'}}active{{/if}}"></div>
			</div>

			<div class="custom-plan">
				<div class="custom-plan_name">custom</div>

				<div class="custom-plan_text">
					For companies that want to offer a smaller or bigger amount than the ones listed above and/or have custom requirements from jsDelivr.
				</div>

				<a class="custom-plan_btn" href="mailto:d@jsdelivr.com?subject=Become a custom sponsor">Become a sponsor</a>
			</div>

			<div class="bottom-info">
				<div class="title">You can sponsor jsDelivr by:</div>
				<div class="list">
					<div>
						<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
						providing us your service for free (CDN, DNS, web hosting, anything else we might need)
					</div>
					<div>
						<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
						making monthly donations to help us cover development costs and other expenses
					</div>
					<div>
						<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
						donating development hours of your employees
					</div>
				</div>
				<div class="descr">
					Your sponsorship level is based on the value of your monthly donation. For example, to become a Bronze sponsor, you
					<br />
					need to sponsor a service worth $150 - 499 per month, donate the same amount of money, or corresponding number
					<br />
					of development hours.
				</div>
				<div>
					Just <a class="mail-us" href="mailto:d@jsdelivr.com?subject=Sponsoring jsDelivr">send us an email</a> if you have any questions.
				</div>
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	component.exports = {
		data () {
			return {
				title: 'Become a Sponsor - jsDelivr',
				description: 'Become a sponsor and help us make jsDelivr better!',
				activePlan: '',
			};
		},
		handleSlider (ractiveThis, wrapper, plansList, tabsWrapper, columnGap) {
			plansList.style.columnGap = `${columnGap}px`;

			let posX1 = 0,
				posX2 = 0,
				posInitial = 0,
				posFinal,
				threshold = 100,
				slides = plansList.querySelectorAll('.plans_wrapper_plans-list_plan'),
				// one slide is Custom plan which is hidden for slider, ergo -1
				slidesLength = slides.length - 1,
				slideWidth = plansList.querySelector('.plans_wrapper_plans-list_plan').offsetWidth,
				currentActiveTabIndex = 0,
				allowShift = true,
				tabs = tabsWrapper.querySelectorAll('.plans_tabs_tab');

			wrapper.classList.add('loaded');

			plansList.onmousedown = handleDragStart;

			plansList.addEventListener('touchstart', handleDragStart);
			plansList.addEventListener('touchend', handleDragEnd);
			plansList.addEventListener('touchmove', handleDragAction);
			plansList.addEventListener('transitionend', handleEndOfTransition);

			tabs.forEach((tab, tabIdx) => {
				tab.addEventListener('click', () => handleTabClick(tab, tabIdx));
			});

			function handleTabClick (tab, tabIdx) {
				if (tabIdx !== currentActiveTabIndex) {
					let shiftSize = tabIdx - currentActiveTabIndex;
					let shiftDir = shiftSize > 0 ? 1 : -1;

					handleShiftSlide(shiftDir, Math.abs(shiftSize));
				}
			}

			function getPlanNameBasedOnIndex (planIndex) {
				switch (planIndex) {
					case 1:
						return 'gold';
					case 2:
						return 'bronze';
					default:
						return '';
				}
			}

			function handleDragStart (e) {
				e.preventDefault();
				posInitial = plansList.offsetLeft;

				if (e.type === 'touchstart') {
					posX1 = e.touches[0].clientX;
				} else {
					posX1 = e.clientX;
					document.onmouseup = handleDragEnd;
					document.onmousemove = handleDragAction;
				}
			}

			function handleDragAction (e) {
				if (e.type === 'touchmove') {
					posX2 = posX1 - e.touches[0].clientX;
					posX1 = e.touches[0].clientX;
				} else {
					posX2 = posX1 - e.clientX;
					posX1 = e.clientX;
				}

				if (
					(plansList.offsetLeft === 0 && (plansList.offsetLeft - posX2) > 0)
					|| (
						plansList.offsetLeft === -((slideWidth + columnGap) * (slidesLength - 1))
						&& (plansList.offsetLeft - posX2) < -((slideWidth + columnGap) * (slidesLength - 1))
					)
				) {
					plansList.style.left = plansList.offsetLeft;
				} else {
					plansList.style.left = `${plansList.offsetLeft - posX2}px`;
				}
			}

			function handleDragEnd () {
				posFinal = plansList.offsetLeft;

				if (posFinal - posInitial < -threshold) {
					handleShiftSlide(1);
				} else if (posFinal - posInitial > threshold) {
					handleShiftSlide(-1);
				} else {
					plansList.style.left = posInitial + 'px';
				}

				document.onmouseup = null;
				document.onmousemove = null;
			}

			function handleShiftSlide (shiftDir, shiftSize = 1) {
				plansList.classList.add('shifting');

				if (allowShift) {
					if (shiftDir === 1) {
						posInitial -= slideWidth * shiftSize + columnGap * shiftSize;
						plansList.style.left = `${posInitial}px`;
						currentActiveTabIndex += shiftSize;
					} else if (shiftDir === -1) {
						posInitial += slideWidth * shiftSize + columnGap * shiftSize;
						plansList.style.left = `${posInitial}px`;
						currentActiveTabIndex -= shiftSize;
					}
				}

				ractiveThis.set('activePlan', getPlanNameBasedOnIndex(currentActiveTabIndex));
				allowShift = false;
			}

			function handleEndOfTransition () {
				plansList.classList.remove('shifting');

				allowShift = true;
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				// init slider only when screen width is larger than 768px
				if (window.innerWidth < 768) {
					let plansListWrapper = document.querySelector('.plans_wrapper');
					let plansList = document.querySelector('.plans_wrapper_plans-list');
					let tabsWrapper = document.querySelector('.plans_tabs');

					this.handleSlider(this, plansListWrapper, plansList, tabsWrapper, 8);
				}
			}
		},
	};
</script>
